<template>
  <div class="settings">
    <span class="title">
      <span>⚙️</span>
      Settings
    </span>

    <form @submit.prevent="updateEmail" class="wrapper" :style="{ '--spacing': spacing + 'px' }">
      <div class="input-container">
        <label>Email Address</label>
        <input v-model="email" type="text" class="w-100" placeholder="Enter your email address">
        <small class="input-note">You can update your email address only once.</small>
      </div>
      <button type="submit">Update</button>
    </form>

    <form @submit.prevent="setReferralCode" class="wrapper" :style="{ '--spacing': spacing + 'px' }">
      <div class="input-container">
        <label>Referral Code</label>
        <input v-model="referralCode" type="text" class="w-100" placeholder="Enter your referral code">
        <small class="input-note">You can set your referral code only once.</small>
      </div>
      <button type="submit">Set</button>
    </form>

    <div class="wrapper" :style="{ '--spacing': spacing + 'px' }">
      <button @click="getLoginData">Get Login Data</button>
      <small class="input-note">With these login details, you can log in to our Android or IOS app to review your information in detail.</small>
    </div>

    <div v-if="loginData" class="login-data">
      <p>Email: {{ loginData.email }}</p>
      <p>Password: {{ loginData.password }}</p>
    </div>

    <div class="referral-code">
      <label>Referral Link:</label>
      <input type="text" :value="referralLink" readonly @click="copyToClipboard(referralLink)">
      <small class="input-note">Click the input to copy the referral link.</small>
    </div>

    <div class="spacing-control">
      <label for="spacing" style="display: none;">Adjust Spacing:</label>

    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SettingsView',
  data() {
    return {
      email: '',
      referralCode: '',
      loginData: null,
      referralLink: '',
      spacing: 1 // Default spacing value
    };
  },
  methods: {
    updateEmail() {
      const telegramId = this.$route.query.telegram_id;
      axios.get(`https://sys.bitherin.com/telegramsetemail?telegram_id=${telegramId}&email=${this.email}`)
          .then(response => {
            if (response.data.success) {
              alert('Email updated successfully.');
            } else {
              alert(response.data.message);
            }
          })
          .catch(error => {
            console.error('Error updating email:', error);
            alert('An error occurred while updating email.');
          });
    },
    setReferralCode() {
      const telegramId = this.$route.query.telegram_id;
      axios.get(`https://sys.bitherin.com/telegramsetref?telegram_id=${telegramId}&code=${this.referralCode}`)
          .then(response => {
            if (response.data.success) {
              alert('Referral code set successfully.');
            } else {
              alert(response.data.message);
            }
          })
          .catch(error => {
            console.error('Error setting referral code:', error);
            alert('An error occurred while setting referral code.');
          });
    },
    getLoginData() {
      const telegramId = this.$route.query.telegram_id;
      axios.get(`https://sys.bitherin.com/telegramgetdata?telegram_id=${telegramId}`)
          .then(response => {
            if (response.data.success) {
              this.loginData = {
                email: response.data.email,
                password: response.data.password
              };
            } else {
              alert('Failed to retrieve login data.');
            }
          })
          .catch(error => {
            console.error('Error fetching login data:', error);
            alert('An error occurred while fetching login data.');
          });
    },
    fetchReferralCode() {
      const telegramId = this.$route.query.telegram_id;
      axios.get(`https://sys.bitherin.com/telegramgetref?telegram_id=${telegramId}`)
          .then(response => {
            if (response.data.success) {
              this.referralLink = `https://t.me/bithermine_bot?start=${response.data.ref_code}`;
            } else {
              alert('Failed to retrieve referral code.');
            }
          })
          .catch(error => {
            console.error('Error fetching referral code:', error);
            alert('An error occurred while fetching referral code.');
          });
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        alert('Referral link copied!');
      }).catch(err => {
        console.error('Error copying text: ', err);
        alert('An error occurred while copying the referral link.');
      });
    }
  },
  created() {
    this.fetchReferralCode();
  }
};
</script>

<style scoped>
:root {
  --spacing: 10px; /* Default spacing value */
}

.settings {
  text-align: center;
  padding: 20px;
  background-color: #0d1319;
  color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  margin-bottom: var(--spacing);
}

.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

label {
  font-size: 14px;
  font-weight: 400;
  color: #757575;
}

input {
  background-color: #040C14;
  border: 1px solid #1d242b;
  border-radius: 3px;
  outline: none;
  color: #fff;
  padding: 10px 12px;
  width: 100%;
}

button {
  width: 100%;
  border: 1px solid transparent;
  background: linear-gradient(to right, #ffa500, #ff4500);
  font-size: 17px;
  font-weight: 500;
  border-radius: 3px;
  padding: 10px 12px;
  color: #fff;
  cursor: pointer;
  margin-top: var(--spacing);
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.title {
  color: #ffa500;
  font-size: 17px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  letter-spacing: .5px;
}

.login-data {
  margin-top: var(--spacing);
}

.referral-code {
  margin-top: var(--spacing);
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.referral-code input {
  cursor: pointer;
  text-align: center;
  width: 100%;
}

.input-note {
  font-size: 12px;
  color: #ffa500;
  margin-top: 3px;
  margin-bottom: var(--spacing);
}

.spacing-control {
  margin-top: 20px;
}

.spacing-control label {
  color: #ffa500;
  font-size: 14px;
}

.spacing-control input {
  width: 100%;
  margin-top: 5px;
}
</style>
